export function countCompletionRate(currentRate) {
  if (currentRate <= 1) return Math.ceil(currentRate * 100)

  return Math.ceil(currentRate)
}
